import { useEffect, useRef, useState } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useLocation, useNavigate } from "react-router";
import { deletes, get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { FaTimes } from "react-icons/fa";
import { Trash } from "../../assets/img/imgIndex";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { toast } from "react-toastify";

const Master = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [page, setPage] = useState(location?.state?.page || 1);
  const [totalCount, setTotalCount] = useState();
  const [pagination, setPagination] = useState(null);
  const [searchText, setSearchText] = useState("");
  const pageRef = useRef(page);
  const preSearchPageRef = useRef(page);
  const [showModel, setShowModel] = useState(false);
  const [kmValue, setKmValue] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const isOpen = () => setShowModel(!showModel);
  const onClose = () => setShowModel(false);

  const initialData = [
    {
      id: 1,
      title: "1",
      description: "This is the first card",
      enabled: false,
    },
    {
      id: 2,
      title: "2",
      description: "This is the second card",
      enabled: true,
    },
    {
      id: 3,
      title: "3",
      description: "This is the third card",
      enabled: false,
    },
  ];

  const [cards, setCards] = useState([]);

  const handleToggle = async (id) => {
    const res = await put(`${URLS.MASTERsTATUS}${id}/`);
    if (res?.status == "success") {
      fetchData();
    }
  };


  const fetchData = async () => {
    let res = await get(`${URLS.MASTERLIST}?type=1`);
    console.log("res master", res);
    if (res?.status == "success") {
      setCards(res?.data);
    }
  };

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  useEffect(() => {
    if (location?.state?.page) {
      // clear state after using it
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [page, searchText]);


  const confirmDelete = async () => {
    setIsDeleteModalOpen(false);
    try {
      const res = await deletes(`${URLS.MASTERDELETE}${selectedItem}/`);
      console.log("delete master res", res);
      if (res?.status === "success") {
        toast.success(res?.message || "Radius deleted successfully");
        fetchData();
      }
    } catch (error) {
      toast.error(error?.message || "Failed to delete radius");
    }
  };

  const handleAdd = async () => {
    onClose();
    if (!kmValue) {
      toast.info("Please enter kilometer value");
      return;
    }
    const res = await post(URLS.MASTERCREATE, {
      type: 1,
      values: {
        kilometer: kmValue,
      }
    });
    console.log("add master res", res);
    if (res?.status === "success") {
      toast.success(res?.message || "Radius added successfully");
      fetchData();
    } else {
      toast.error(res?.message || "Failed to add radius");
    }
  }

  return (
    <div>

      <div className="header-row">
        <PageHeader title="Delivery Radius" />
        <button className="header-action-btn" onClick={() => {
          isOpen();
          setKmValue("");
        }} >
          + Add Radius
        </button>
      </div>

      <div className="master-grid">
        {cards.map((card) => (
          <div key={card.id} className="master-card">
            <div style={{ display: 'flex', justifyContent: "space-between" }}>
              <h2 className="master-title">{`${card?.values?.kilometer} KM`}</h2>
              <label className="master-switch">
                <input
                  type="checkbox"
                  checked={card?.status === 1}
                  onChange={() => handleToggle(card?.id)}
                />
                <span className="master-slider"></span>
              </label>
            </div>
            <button className="description-row" onClick={() => {
              setSelectedItem(card?.id);
              setIsDeleteModalOpen(true);
            }}>
              <img src={Trash} width={22} height={22} />
              <p className="master-description">Delete</p>
            </button>

          </div>
        ))}
      </div>


      {showModel && (
        <div className="drm-overlay" onClick={onClose}>
          <div
            className="drm-container"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="drm-title">Delivery Radius</h2>

            <div className="drm-value-row">
              <input value={kmValue} type="number" onChange={(e) => setKmValue(e.target.value)} className="drm-value" />
              <span className="drm-unit">KM</span>
            </div>

            <hr className="drm-divider" />

            <button onClick={handleAdd} className="drm-button">
              <span className="drm-plus">+</span>
              Add Radius
            </button>

            <button className="drm-close" onClick={onClose}>
              ✕
            </button>
          </div>
        </div>)}

      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={confirmDelete}
        message="Are you sure you want to delete?"
      />
    </div>
  );
};

export default Master;
